import { useState } from "react"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Badge } from "./ui/badge"
import { Button } from "./ui/button"
import { Input } from "./ui/input"
import { Search } from "lucide-react"

interface Prueba {
  id: string
  nombre: string
  tipo: "Fisico" | "Quimico"
  descripcion: string
  tiempoEstimado: string
}

export const pruebasDisponibles: Prueba[] = [
  {
    id: "5",
    nombre: "NMX-A-5077-INNTEX-2015 / NMX-A-6330-INNTEX-2015 CAMBIOS DIMENSIONALES",
    tipo: "Fisico",
    descripcion: "Evaluación de cambios dimensionales en textiles",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "1",
    nombre: "NMX-A-172-INNTEX-2012 RESISTENCIA A LA ABRASIÓN PLANA TABER",
    tipo: "Fisico",
    descripcion: "Determinación de la resistencia a la abrasión mediante el método Taber",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "2",
    nombre: "NMX-A-12945-3-INNTEX-2020 DETERMINACIÓN DE FRISAS, VELLOSIDAD Y EMARAÑAMIENTO",
    tipo: "Fisico", 
    descripcion: "Evaluación de características superficiales del tejido mediante prueba de frisas, vellosidad y emarañamiento",
    tiempoEstimado: "1 día"
  },
  {
    id: "3",
    nombre: "ANÁLISIS QUÍMICO CUALITATIVO Y CUANTITATIVO",
    tipo: "Quimico",
    descripcion: "Identificación y cuantificación de componentes químicos",
    tiempoEstimado: "3-5 días"
  },
  {
    id: "4",
    nombre: "NMX-A-134-INNTEX-2013 DENSIDAD DE TEJIDO DE PUNTO",
    tipo: "Fisico",
    descripcion: "Medición de la densidad en tejidos de punto",
    tiempoEstimado: "1 día"
  },
  {
    id: "6",
    nombre: "NMX-A-229-1982 Determinación del pH y Δ pH de un extracto acuoso de cuero",
    tipo: "Quimico",
    descripcion: "Medición de pH en extractos acuosos de cuero",
    tiempoEstimado: "1 día"
  },
  {
    id: "7",
    nombre: "NMX-A-3801-INNTEX-2012 PESO DE LA TELA (METODO 5)",
    tipo: "Fisico",
    descripcion: "Determinación del peso por unidad de área de la tela",
    tiempoEstimado: "1 día"
  },
  {
    id: "8",
    nombre: "NMX-A-4920-INNTEX-2017 RESISTENCIA AL HUMEDECIMIENTO SUPERFICIAL (MÉTODO DE ROCÍO)",
    tipo: "Fisico",
    descripcion: "Evaluación de la resistencia al humedecimiento superficial",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "9",
    nombre: "NMX-A-109-INNTEX-2012 RESISTENCIA AL RASGADO",
    tipo: "Fisico",
    descripcion: "Determinación de la resistencia al rasgado de textiles",
    tiempoEstimado: "1 día"
  },
  {
    id: "10",
    nombre: "NMX-A-230-1982 Determinación del contenido de cromo",
    tipo: "Quimico",
    descripcion: "Cuantificación del contenido de cromo en muestras",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "11",
    nombre: "NMX-A-7211/2-INNTEX-2015 DENSIDAD DE TEJIDO PLANO (METODO A)",
    tipo: "Fisico",
    descripcion: "Medición de la densidad en tejidos planos",
    tiempoEstimado: "1 día"
  },
  {
    id: "12",
    nombre: "NMX-A-228-1982 Determinación de cenizas totales y cenizas insolubles en agua",
    tipo: "Quimico",
    descripcion: "Determinación cuantitativa de cenizas totales e insolubles",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "13",
    nombre: "NMX-A-225-1982 Determinación de humedad en cuero",
    tipo: "Quimico",
    descripcion: "Medición del contenido de humedad en cuero",
    tiempoEstimado: "1 día"
  },
  {
    id: "14",
    nombre: "NMX-A-073-INNTEX-2005 SOLIDEZ DEL COLOR AL FROTE",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color al frote",
    tiempoEstimado: "1 día"
  },
  {
    id: "15",
    nombre: "TIPO DE TEJIDO MET-7.2-11",
    tipo: "Fisico",
    descripcion: "Identificación y clasificación del tipo de tejido",
    tiempoEstimado: "1 día"
  },
  {
    id: "16",
    nombre: "NMX-A-105-E04-INNTEX-2019 SOLIDEZ DEL COLOR AL SUDOR",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color al sudor",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "17",
    nombre: "NMX-A-9073/1-INNTEX-2018 MASA DE NO TEJIDOS",
    tipo: "Fisico",
    descripcion: "Determinación de la masa por unidad de área de no tejidos",
    tiempoEstimado: "1 día"
  },
  {
    id: "18",
    nombre: "NMX-A-083-INNTEX-2020 EVALUACIÓN DE CONFECCIÓN Y DIMENSIÓN DE PRENDAS",
    tipo: "Fisico",
    descripcion: "Evaluación de características de confección y dimensionales",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "19",
    nombre: "NMX-A-105-C06-INNTEX-2015 SOLIDEZ DEL COLOR AL LAVADO DOMESTICO E INDUSTRIAL",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color al lavado",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "20",
    nombre: "NMX-A-275/5-INNTEX-2000 DENSIDAD LINEAL DE HILOS EXTRAIDOS DE LA TELA (METODO A)",
    tipo: "Fisico",
    descripcion: "Medición de la densidad lineal de hilos",
    tiempoEstimado: "1 día"
  },
  {
    id: "21",
    nombre: "TIPO DE LIGAMENTO MET-7.2-12",
    tipo: "Fisico",
    descripcion: "Identificación del tipo de ligamento en tejidos",
    tiempoEstimado: "1 día"
  },
  {
    id: "22",
    nombre: "TIPO DE ACABADO MET-7.2-19",
    tipo: "Fisico",
    descripcion: "Identificación y caracterización del tipo de acabado",
    tiempoEstimado: "1 día"
  },
  {
    id: "23",
    nombre: "NMX-A-221-1982 Determinación de las grasas y otros materiales solubles por extracción con cloruro de metileno",
    tipo: "Quimico",
    descripcion: "Cuantificación de grasas y materiales solubles mediante extracción",
    tiempoEstimado: "2-4 días"
  },
  {
    id: "24",
    nombre: "NMX-A-105-D01-INNTEX-2020 SOLIDEZ DEL COLOR AL LAVADO EN SECO",
    tipo: "Quimico",
    descripcion: "Determinación de la solidez del color al lavado en seco con percloroetileno",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "25",
    nombre: "NMX-A-105-B02-INNTEX-2019 DETERMINACIÓN DE LA SOLIDEZ DEL COLOR A LA LUZ ARTIFICIAL: ENSAYO DE LA LÁMPARA DE DECOLORACIÓN DE ARCO DE XENÓN",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color a la luz artificial mediante lámpara de arco de xenón",
    tiempoEstimado: "2-5 días"
  },
  {
    id: "26",
    nombre: "NMX-A-059/1-INNTEX-2019 DETERMINACIÓN DE LA FUERZA MÁXIMA Y DEL ALARGAMIENTO A LA FUERZA MÁXIMA POR EL MÉTODO DE LA TIRA",
    tipo: "Fisico",
    descripcion: "Determinación de la fuerza máxima y alargamiento por el método de la tira",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "27",
    nombre: "Propiedades de los tejidos frente a la tracción-Parte 2: Determinación de la fuerza máxima por el método de agarre-Método Grab. NMX-059/2-INNTEX-2019",
    tipo: "Fisico",
    descripcion: "Determinación de la fuerza máxima por el método de agarre (Grab)",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "28",
    nombre: "AATCC TM127-2017(2018) TEST METHOD FOR WATER RESISTANCE: HYDROSTATIC PRESSURE",
    tipo: "Fisico",
    descripcion: "Determinación de la resistencia al agua mediante presión hidrostática",
    tiempoEstimado: "1 día"
  },
  {
    id: "29",
    nombre: "NMX-S-051-1989 Numeral 7.1.1 Resistencia a la flexión",
    tipo: "Fisico",
    descripcion: "Determinación de la resistencia a la flexión en seco y húmedo",
    tiempoEstimado: "3-7 días"
  },
  {
    id: "30",
    nombre: "PRUEBA ADICIONAL",
    tipo: "Fisico",
    descripcion: "Prueba personalizada: se captura nombre y fecha, y se adjunta un documento Word que se muestra en el Reporte de Cliente y la Bitácora",
    tiempoEstimado: "Variable"
  }
]

interface PruebaSelectorProps {
  isOpen: boolean
  onClose: () => void
  onSelectPrueba: (prueba: Prueba) => void
}

export function PruebaSelector({ isOpen, onClose, onSelectPrueba }: PruebaSelectorProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const [areaFiltro, setAreaFiltro] = useState<"" | "Fisico" | "Quimico">("");

  // Función para normalizar texto (quitar acentos y convertir a minúsculas)
  const normalizeText = (text: string) => {
    return text.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
  }

  const filteredPruebas = pruebasDisponibles.filter(prueba => {
    if (areaFiltro && prueba.tipo !== areaFiltro) return false;
    const searchNormalized = normalizeText(searchTerm)
    
    // Crear versiones alternativas del nombre para búsqueda más flexible
    const nombreOriginal = normalizeText(prueba.nombre)
    const nombreConY = nombreOriginal.replace(/\s*\/\s*/g, ' y ')  // Reemplaza " / " con " y "
    const nombreConSlash = nombreOriginal.replace(/\s*y\s*/g, ' / ')  // Reemplaza " y " con " / "
    
    return (
      nombreOriginal.includes(searchNormalized) ||
      nombreConY.includes(searchNormalized) ||
      nombreConSlash.includes(searchNormalized) ||
      normalizeText(prueba.descripcion).includes(searchNormalized) ||
      normalizeText(prueba.tipo).includes(searchNormalized) ||
      normalizeText(prueba.tiempoEstimado).includes(searchNormalized)
    )
  })

  // Ordenar pruebas: primero por nombre (alfabético), luego por número si hay números al inicio
  const pruebasOrdenadas = [...filteredPruebas].sort((a, b) => {
    // Extraer número inicial si existe
    const numA = a.nombre.match(/^\D*(\d+)/)?.[1];
    const numB = b.nombre.match(/^\D*(\d+)/)?.[1];
    if (a.nombre.toLowerCase() === b.nombre.toLowerCase()) {
      // Si el nombre es igual, ordenar por número
      if (numA && numB) return parseInt(numA) - parseInt(numB);
      if (numA) return -1;
      if (numB) return 1;
      return 0;
    }
    // Si el nombre es diferente, ordenar alfabéticamente
    return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });
  });

  const handleSelectPrueba = (prueba: Prueba) => {
    onSelectPrueba(prueba)
    onClose()
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[80vw] sm:max-w-[80vw] w-full max-h-[90vh]">
        <div className="px-8 py-6">
          <DialogHeader>
            <DialogTitle>Seleccionar Prueba</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            Seleccione una prueba de la lista para agregar al pedido. {pruebasOrdenadas.length} de {pruebasDisponibles.length} pruebas disponibles.
          </DialogDescription>
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  type="text"
                  placeholder="Buscar por nombre, descripción, tipo... (ej: 5077 y 6330, cambios dimensionales)"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="flex gap-2">
                <Button
                  type="button"
                  variant={areaFiltro === "Fisico" ? "default" : "outline"}
                  className="px-4"
                  onClick={() => setAreaFiltro(areaFiltro === "Fisico" ? "" : "Fisico")}
                >
                  Físicas
                </Button>
                <Button
                  type="button"
                  variant={areaFiltro === "Quimico" ? "default" : "outline"}
                  className="px-4"
                  onClick={() => setAreaFiltro(areaFiltro === "Quimico" ? "" : "Quimico")}
                >
                  Químicas
                </Button>
              </div>
            </div>

            <div className="max-h-[500px] overflow-y-auto">
              {pruebasOrdenadas.length === 0 && searchTerm ? (
                <div className="text-center py-8">
                  <p className="text-muted-foreground">No se encontraron pruebas que coincidan con "{searchTerm}"</p>
                </div>
              ) : (
                <div className="flex flex-col gap-3">
                  {pruebasOrdenadas.map((prueba) => (
                    <Card
                      key={prueba.id}
                      className="cursor-pointer hover:shadow-lg transition-shadow"
                      onClick={() => handleSelectPrueba(prueba)}
                    >
                      <CardHeader className="pb-2">
                        <div className="flex justify-between items-start gap-2">
                          <CardTitle className="text-sm leading-tight">{prueba.nombre}</CardTitle>
                          <Badge variant={prueba.tipo === "Fisico" ? "default" : "outline"} className="shrink-0">
                            {prueba.tipo}
                          </Badge>
                        </div>
                      </CardHeader>
                      <CardContent className="pt-0">
                        <div className="space-y-2">
                          <div>
                            <label className="text-muted-foreground">Descripción</label>
                            <p className="text-sm">{prueba.descripcion}</p>
                          </div>
                          <div>
                            <label className="text-muted-foreground">Tiempo Estimado</label>
                            <p className="text-sm">{prueba.tiempoEstimado}</p>
                          </div>
                          <Button size="sm" className="w-full mt-2">
                            Seleccionar Prueba
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}